import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClock = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	stroke: "currentColor",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.66602 1.33325H9.33268",
			strokeWidth: 1,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 9.33325L10 7.33325",
			strokeWidth: 1,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.99935 14.6667C10.9449 14.6667 13.3327 12.2789 13.3327 9.33333C13.3327 6.38781 10.9449 4 7.99935 4C5.05383 4 2.66602 6.38781 2.66602 9.33333C2.66602 12.2789 5.05383 14.6667 7.99935 14.6667Z",
			strokeWidth: 1,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgClock;
